
import CardCont from './Components/CardCont';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="o-card-cont-principal">
      <CardCont ></CardCont>
      </div>
    </div>
  );
}

export default App;
